import React, { useEffect, useRef, useState } from "react";
import styled from "styled-components";
import { lightThemeColors } from "../../assets/styles/colors";
import ConfigurationSectionHeader from "../configurationComponents/ConfigurationSectionHeader";
import InputFieldWithValidation from "../Generic/InputFieldWithValidation";
import { useExpanded } from "../../hooks/useExpanded";

const UTMSParamsLink = ({
  utmCampaign,
  setUtmCampaign,
  utmMedium,
  setUtmMedium,
  utmSource,
  setUtmSource,
  noLabel,
}) => {
  const [expanded, expand] = useExpanded(false);

  return (
    <Container>
      <ConfigurationSectionHeader
        title={"Tracking"}
        handleExpand={expand}
        expanded={expanded}
        optionalLabel={!noLabel}
        isValid={true}
      />

      {expanded && (
        <ContentContainer>
          <SubcategoryContent>
            <ColumnGroup>
              <HeaderWrapper>
                <p>
                  These parameters are added to your redirect URLs to track
                  where the traffic is coming from. They can be used by Google
                  Analytics, the Google Play Store, or the Apple App Store to
                  identify the source, medium, and campaign associated with the
                  link.
                </p>
              </HeaderWrapper>
              <InputFieldWithValidation
                title={"Campaign source"}
                placeholder={"Source"}
                noValidation
                inputValue={utmSource}
                subtitle={
                  "Specifies the source of your traffic — such as the website, platform, or publisher where the link was shared. This parameter helps you identify who or what is sending visitors to your app or website."
                }
                handleInputChange={(e) => setUtmSource(e.currentTarget.value)}
              />
              <InputFieldWithValidation
                title={"Campaign medium"}
                placeholder={"Medium"}
                noValidation
                inputValue={utmMedium}
                subtitle={
                  "Identifies the marketing channel or medium used to share the link. This parameter helps categorize the type of traffic, such as email, social media, paid ads, or organic."
                }
                handleInputChange={(e) => setUtmMedium(e.currentTarget.value)}
              />
              <InputFieldWithValidation
                title={"Campaign name"}
                placeholder={"Campaign"}
                noValidation
                inputValue={utmCampaign}
                subtitle={
                  "Specifies the name of the marketing campaign or promotion associated with the link. This parameter is used to group traffic and measure the effectiveness of individual campaigns."
                }
                handleInputChange={(e) => setUtmCampaign(e.currentTarget.value)}
              />
            </ColumnGroup>
          </SubcategoryContent>
        </ContentContainer>
      )}
    </Container>
  );
};

export default UTMSParamsLink;

const HeaderWrapper = styled.div`
  p {
    color: ${lightThemeColors.inputSubtitleColor};
    font-size: 14px;
    font-weight: 400;
    line-height: 24px;
  }
`;

const Container = styled.div`
  display: flex;
  flex-direction: column;
  background: ${lightThemeColors.background};
  width: 100%;
  gap: 10px;
`;

const ContentContainer = styled.div`
  display: flex;
  overflow: hidden;
  flex-wrap: wrap;
  padding-bottom: 20px;
  row-gap: 20px;
`;
const SubcategoryContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: 30px;
  width: 100%;
  max-width: 620px;
`;
const Line = styled.div`
  display: flex;
  align-items: center;
  gap: 0px;
`;

const SeparatorNoMargin = styled.div`
  display: flex;
  height: 1px;
  width: 100%;
  background: ${lightThemeColors.darkColor};
  opacity: 0.1;
`;
const ColumnGroup = styled.div`
  display: flex;
  flex-direction: column;
  gap: 15px;
  width: 100%;
`;
